export const DEFAULT_NEW_REPORT_VALUES = {
	name: 'New Custom Report',
	chartType: 'AREA',
	template: 'custom',
	config: {
		dataType: null,
		dataSet: null,
		dimensions: [],
		measures: [],
		sort: {
			direction: null,
			by: null,
		},
		filters: [],
		compare: false,
		limit: '10',
		rowTotals: false,
		stacked: false,
		points: false,
		colorTheme: 'default' ,
	},
};
